/* eslint-disable @typescript-eslint/no-explicit-any */
// Note: All the logic for the utils here will be extracted to their
// own service in the future.
// This was mostly copied from our frontend-core package
import { get, getOr, isObject, isString } from 'lodash/fp';

import { Vertical } from '../../../common/enums';
import { IGetPageNameAndVerticalByPath } from '../../../modules/cms-processwire/types/path-mapper.type';

/*  TODO: urlMap on frontend-shared was ref by @client(country-instance)
let's keep it as a param any and thing a way to change it in the future */

const getPageNameAndVerticalByPath = (
  path: string,
  urlMap: any,
  obj: { [key: string]: any } = urlMap.b2c,
): IGetPageNameAndVerticalByPath => {
  const result = {} as IGetPageNameAndVerticalByPath;
  const keys = Object.keys(obj);

  for (const key of keys) {
    for (const childKey of Object.keys(obj[key])) {
      if (isObject(obj[key][childKey])) {
        Object.assign(
          result,
          getPageNameAndVerticalByPath(path, urlMap, obj[key][childKey]),
        );
      }

      if (obj[key][childKey] === decodeURIComponent(path)) {
        Object.assign(result, {
          vertical: key,
          pageName: childKey,
        });
      }
    }
  }

  return result;
};

const getFlowAndPartnerByPath = (
  path: string,
  urlMap: any,
  obj: { [key: string]: any } | string = urlMap,
  depth = 0,
): Record<string, string> | boolean => {
  const keys = Object.keys(obj);
  let found = false;

  for (const key of keys) {
    if (isObject(get(key, obj))) {
      for (const childKey of Object.keys(get(key, obj))) {
        found = getFlowAndPartnerByPath(
          path,
          get(key, obj)[childKey],
          urlMap,
          depth + 1,
        ) as boolean;

        // Need this to check if URL was found and we are at top object level
        // At top object level return the source and flow
        if (found && depth === 0) {
          return {
            flow: key,
            partner: childKey,
          };
        }

        // We found the URL but we are still not at top level
        // keep returning the recursion until we reach top level
        if (found) {
          return true;
        }
      }
    }

    const decodedUrl = decodeURIComponent(path);
    if (obj === decodedUrl || get(key, obj) === decodedUrl) {
      return true;
    }
  }

  // We didnt found the URL and we are at top level
  // return the default source and flow
  if (depth === 0) {
    return {
      source: 'b2c',
      flow: 'Direct',
    };
  }

  return false;
};

const getPage = (source: string, locale: string, page = 'default', urlMap: any): string => {
  const url = get(`${source}.Direct.${locale}.${page}`, urlMap);

  return url || (locale !== 'en' ? '/' : `/${locale}`);
};

const getUrl = (
  page: string,
  vertical: Vertical,
  locale: string,
  source = 'b2c',
  entity = '',
  query: Record<string, string> = {},
  host: string,
  urlMap: any,
): string => {
  const [p, v, l, s, e] = [page, vertical, locale, source, entity].map((val) =>
    isString(val) ? val.toLocaleLowerCase() : '',
  );

  const url =
    getOr(
      get(`${s}.${e}.${l}.${p}`, urlMap),
      `${s}.${e}.${l}.${v}.${p}`,
      urlMap,
    ) ||
    getOr(
      get(`${s}.Direct.${l}.${p}`, urlMap),
      `${s}.Direct.${l}.${v}.${p}`,
      urlMap,
    ) ||
    getPage(s, l, undefined, urlMap);

    const finalUrl = new URL(url || getPage(s, l, undefined, urlMap), host);

    Object.keys(query).forEach((key) => {
      finalUrl.searchParams.set(key, query[key]);
    });

    return finalUrl.toString();
};

const parseUtms = (utms: Record<string, string>): string => {
  if (!utms) {
    return '';
  }
  const keys = Object.keys(utms);
  return keys
    .filter((utmKey) => utms[utmKey] && utms[utmKey] !== 'Direct')
    .map((utmKey) => `utm_${utmKey}=${utms[utmKey]}`)
    .join('&');
};

export {
  getPageNameAndVerticalByPath,
  getFlowAndPartnerByPath,
  getPage,
  getUrl,
  parseUtms,
};
